import React, { useState, useEffect } from 'react';

export function OrderSuccess({ orderId, onClose }) {
  const [order, setOrder] = useState(null);
  const [fetchErr, setFetchErr] = useState(false);
  const STATUS = { pending: '⏳ Pending', confirmed: '✅ Confirmed', shipped: '🚚 Shipped', delivered: '🎉 Delivered', cancelled: '❌ Cancelled' };

  useEffect(() => {
    fetch(`/api/get-order?id=${orderId}`)
      .then(r => r.json())
      .then(data => setOrder(data))
      .catch(() => setFetchErr(true));
  }, [orderId]);

  return (
    <div className="modal-overlay">
      <div className="modal-box success-modal">
        <div className="success-icon">🎉</div>
        <h2>Order Confirmed!</h2>
        <p>Thank you! We'll send you order updates and delivery details via email.</p>

        <div className="order-id-save-box">
          <div className="order-id-display">
            <code className="order-id-full">{orderId}</code>
          </div>
        </div>

        {order && (
          <div className="order-details-box">
            <div className="order-detail-row"><span>Status</span><span>{STATUS[order.status] || order.status}</span></div>
            <div className="order-detail-row"><span>Amount Paid</span><strong>₹{order.total}</strong></div>
          </div>
        )}
        {fetchErr && <p className="form-error">Could not load order details.</p>}
        <button className="btn-primary" onClick={onClose}>Continue Shopping</button>
      </div>
    </div>
  );
}
